//051914
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { VirtuosoGrid } from 'react-virtuoso';

import { getApi } from '../funciones/sesion.js';
import mp from '../assets/img/ic_home/mp.png';
import fb from '../assets/img/ic_home/fb.png';
import separador from '../assets/img/separador.png';

var path = "https://laescobaencantada.com.mx/banners/recom/";

const AdapterSugeridosReact = () => {
    const scrollContainerRef = useRef(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [menuItems, setmenuItems] = useState([]);

    // 1. CÁLCULO DEL EFECTO FISHEYE
    const applyFisheyeEffect = useCallback(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const rect = container.getBoundingClientRect();
        const centerX = rect.width / 2;
        const centerY = rect.height / 1.8;
        const maxDistance = Math.min(centerX, centerY);

        // Si el contenedor no tiene dimensiones aún (muy común al iniciar en Prod), no calculamos
        if (maxDistance <= 0) return;

        const children = container.querySelectorAll('.sugerido-card');
        if (children.length === 0) return;

        children.forEach((child) => {
            const childRect = child.getBoundingClientRect();

            const childCenterX = childRect.left + childRect.width / 2 - rect.left;
            const childCenterY = childRect.top + childRect.height / 2 - rect.top;

            const distance = Math.hypot(childCenterX - centerX, childCenterY - centerY);
            const distanceRatio = distance / maxDistance;

            const scale = Math.max(0.4, 1.2 - distanceRatio * 0.45);
            const alpha = Math.max(0.4, 1.2 - distanceRatio * 0.45);

            child.style.transform = `scale(${scale})`;
            child.style.opacity = alpha;
        });
    }, []);

    // 2. PETICIÓN A LA API
    useEffect(() => {
        getApi("getRecom/").then(data => {
            if (data && data.elementos) {
                setmenuItems(data.elementos);
            }
        }).catch(err => console.error("Error al obtener recomendaciones:", err));
    }, []);

    // 3. RESIZE OBSERVER (Solución para Producción)
    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container || menuItems.length === 0) return;

        // Ejecución inmediata
        applyFisheyeEffect();

        // El ResizeObserver detecta cuando las imágenes o la grid cambian de tamaño/layout en Prod
        const resizeObserver = new ResizeObserver(() => {
            applyFisheyeEffect();
        });

        resizeObserver.observe(container);

        // También observamos cambios en el DOM interno (cuando Virtuoso inserta las cards)
        const mutationObserver = new MutationObserver(() => {
            applyFisheyeEffect();
        });

        mutationObserver.observe(container, { childList: true, subtree: true });

        window.addEventListener('resize', applyFisheyeEffect);

        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            window.removeEventListener('resize', applyFisheyeEffect);
        };
    }, [menuItems, applyFisheyeEffect]);

    const redirigir = (url) => {
        if (url) window.open(url, '_blank');
    };

    if (!menuItems || menuItems.length === 0) {
        return <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>Cargando recomendaciones...</div>;
    }

    return (
        <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ width: '100%', maxWidth: '800px', position: 'fixed', background: '#fffefed7', zIndex: 1, marginTop: 50, padding: '15px 25px', textAlign: 'center' }}>
                <p className='rage-'>¡Nuestros lugares favoritos!</p>
                <div className="separador center-v-">
                    <img src={separador} className="img-responsive" alt="separador" />
                </div>
                <p style={{ fontSize: 10 }}>¿No sabes por dónde empezar? Aquí están nuestras mejores recomendaciones: los sitios con más sabor, el mejor ambiente y las opciones mejor valoradas por nosotros, para que no lo pienses tanto y solo disfrutes.</p>
            </div>

            {/* Contenedor del Scroll */}
            <div
                ref={scrollContainerRef}
                onScroll={applyFisheyeEffect}
                style={{
                    width: '100%',
                    height: '100vh',
                    overflowY: 'auto',
                    padding: '40px 0',
                    zIndex: 0,
                    position: 'absolute'
                }}
            >
                <VirtuosoGrid
                    customScrollParent={scrollContainerRef.current || undefined}
                    totalCount={10000}
                    listClassName="grid-sugeridos"
                    itemContent={(index) => {
                        const item = menuItems[index % menuItems.length];
                        if (!item) return null;

                        return (
                            <div className="card-wrapper">
                                <div
                                    className="sugerido-card"
                                    onClick={() => setSelectedItem(item)}
                                >
                                    <img
                                        src={path + item.url}
                                        alt={item.nombre || 'Recomendación'}
                                        className="avatar-img"
                                        onLoad={applyFisheyeEffect}
                                        onError={(e) => {
                                            e.target.src = 'https://via.placeholder.com/150';
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}
                />
            </div>

            {/* MODAL / EMERGENTE RECOMENDACIÓN */}
            {selectedItem && (
                <div className="modal-overlay" onClick={() => setSelectedItem(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-head">
                            <h2>{selectedItem.nombre}</h2>
                        </div>

                        <img
                            src={path + selectedItem.url}
                            alt={selectedItem.nombre}
                            className="modal-avatar"
                            onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/150';
                            }}
                        />

                        <p><i>{selectedItem.direccion}</i></p>

                        <div className="modal-actions">
                            <img
                                src={fb}
                                alt="Facebook"
                                onClick={() => redirigir(selectedItem.fb)}
                                className={`btn-icon ${!selectedItem.fb ? 'disabled' : ''}`}
                            />
                            <img
                                src={mp}
                                alt="Google Maps"
                                onClick={() => redirigir(selectedItem.maps)}
                                className={`btn-icon ${!selectedItem.maps ? 'disabled' : ''}`}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* ESTILOS CSS */}
            <style>{`
                .grid-sugeridos {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 30px 10px;
                    padding: 60px 20px;
                }

                .card-wrapper {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .grid-sugeridos > div:nth-child(3n + 2) .sugerido-card {
                    margin-top: 35px;
                }

                .sugerido-card {
                    width: 85px;
                    height: 85px;
                    border-radius: 50%;
                    cursor: pointer;
                    will-change: transform, opacity;
                    transition: transform 0.1s ease-out, opacity 0.1s ease-out;
                }

                .avatar-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                }

                .modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }

                .modal-content {
                    display: flex;
                    background: white;
                    border-radius: 16px;
                    text-align: center;
                    max-width: 320px;
                    width: 90%;
                    flex-direction: column;
                    align-items: center;
                    padding-bottom: 40px;
                }

                .modal-content > p {
                    padding: 15px;
                }

                .modal-head {
                    font-family: "Rage", cursive;
                    background: #f4f4f4;
                    height: 150px;
                    text-align: center;
                    padding: 30px;
                    width: 100%;
                    box-shadow: -1px 0px 15px -3px rgba(0, 0, 0, 0.2);
                }

                .modal-avatar {
                    transform: translateY(-50px);
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin-bottom: 12px;
                }

                .modal-actions {
                    display: flex;
                    gap: 12px;
                    justify-content: center;
                    margin: 20px;
                }

                   .modal-actions > img {
                    margin: 0 20px
                }

                .btn-icon {
                    width: 50px;
                    height: 50px;
                    cursor: pointer;
                }

                .btn-icon.disabled {
                    filter: sepia(1);
                    opacity: 0.5;
                    pointer-events: none;
                }

                .rage- {
                    font-size: 30px;
                    font-family: "Rage", cursive;
                }

                .img-responsive {
                    display: block;
                    width: 100%;
                    height: auto;
                }
            `}</style>
        </div>
    );
};

export default AdapterSugeridosReact;